export default "__VITE_ASSET__69c93599__"